// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"AlertNotification_popupContainer__CamDO","error":"AlertNotification_error__Qyv6v"};